import { inject, injectable } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@/Framework/api/Rpc/Request';
import RpcDispatcher from '@/finsight/application/DI/Rpc/finsight-web/HttpDispatcher';
import BaseFinsightRepository from '@/finsight/infrastructure/repository/BaseFinsightRepository';

@injectable()
class ScorecardRepository extends BaseFinsightRepository {
  constructor(@inject(RpcDispatcher) protected readonly rpc: typeof RpcDispatcher) {
    super(rpc);
  }

  getCompaniesAll = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_companies',
      {
        ...payload,
        filters: {
          ...payload.filters,
          includedRoles: ['ratingAgency', 'underwriter'],
        },
      },
    );
    return this.abortableCall(request, 'ratingAgencyAndUnderwriter');
  };

  getCompaniesRatingAgency = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_companies',
      {
        ...payload,
        filters: {
          ...payload.filters,
          includedRoles: ['ratingAgency'],
        },
      },
    );
    return this.abortableCall(request, 'ratingAgency');
  };

  getCompaniesUnderwriter = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_companies',
      {
        ...payload,
        filters: {
          ...payload.filters,
          includedRoles: ['underwriter'],
        },
      },
    );
    return this.abortableCall(request, 'underwriter');
  };

  getCompaniesTtmFilter = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_companies.get_ttm_filter',
      {
        filters: {
          ...payload,
          includedRoles: ['ratingAgency', 'underwriter'],
        },
      },
    );
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getTopCompaniesRatingAgency = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_top_companies',
      {
        ...payload,
        filters: {
          ...payload.filters,
          includedRole: 'ratingAgency',
        },
      },
    );
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getTopCompaniesRatingAgencyTtmFilter = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_top_companies.get_ttm_filter',
      {
        filters: {
          ...payload,
          includedRole: 'ratingAgency',
        },
      },
    );
    const response = await this.rpc.call<RpcSuccess>(request);
    return response.getResult().payload;
  };

  getTopCompaniesUnderwriter = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_top_companies',
      {
        ...payload,
        filters: {
          ...payload.filters,
          includedRole: 'underwriter',
        },
      },
    );
    const response = await this.rpc.call<RpcSuccess>(request);
    return response.getResult().payload;
  };

  getTopCompaniesUnderwriterTtmFilter = async (payload) => {
    const request = new Request(
      'finsight_web.market.scorecard.get_top_companies.get_ttm_filter',
      {
        filters: {
          ...payload,
          includedRole: 'underwriter',
        },
      },
    );
    const response = await this.rpc.call<RpcSuccess>(request);
    return response.getResult().payload;
  };

  getStandings = async (payload) => {
    const request = new Request('finsight_web.market.scorecard.company.get_standings_data', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default ScorecardRepository;
